<template>
  <section>
    <div class="container">
      <div class="case-studies-wrapper">
        <h1>Historie pacjentek</h1>
        <div class="case-studies-grid">
          <div class="case-study" v-for="(caseStudy, index) in caseStudies" v-bind:key="caseStudy.name">
            <img :src="caseStudy.image" :alt="`${caseStudy.name} - case study`" v-if="caseStudy.image" />
            <h3>{{caseStudy.name}}</h3>
            <p>{{truncate(caseStudy.description)}}</p>
            <button @click="openModal(index)">Czytaj więcej</button>
          </div>

        </div>
      </div>
    </div>

    <div :class="{'modal-wrapper':true, 'open': modalCaseStudyIndex != -1}" @click="closeModal"
      @scroll="$event.stopPropagation()">
      <button class="close-modal" @click="closeModal">&times; Zamknij</button>
      <div class="modal" @click="$event.stopPropagation()">
        <img :src="modalCaseStudy.image" :alt="`${modalCaseStudy.name} - case study`" v-if="modalCaseStudy.image" />
        <h1>{{modalCaseStudy.name}}</h1>

        <p>
          {{modalCaseStudy.description}}
        </p>

      </div>
    </div>
  </section>
</template>

<script>
  import truncate from 'truncate'
  export default {
    data: () => ({
      caseStudies: require('../../data/caseStudies.js'),
      modalCaseStudyIndex: -1,
      scrollY: 0
    }),
    computed: {
      modalCaseStudy() {
        if (this.modalCaseStudyIndex != -1) {
          return this.caseStudies[this.modalCaseStudyIndex]
        }
        return {
          name: '',
          image: null,
          description: ''
        }
      }
    },
    methods: {
      truncate(txt) {
        return truncate(txt, 300)
      },
      openModal(idx) {
        this.modalCaseStudyIndex = idx;
        document.body.style.overflow = 'hidden'
      },
      closeModal() {
        document.body.style.overflow = 'auto'
        this.modalCaseStudyIndex = -1;
      }
    },
    mounted() {
      window.addEventListener('scroll', () => this.scrollY = window.scrollY);
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../vars';

  .case-studies-wrapper{
    margin-top: 5em;
  }
  .case-studies-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 3em;

    @media(max-width: 580px) {
      grid-template-columns: 1fr;
      grid-row-gap: 3em;
    }

    .case-study {
      padding: 10px 1em;
      background: rgba(245, 245, 245, 0.7);
      margin-top: 2em;

      img {
        width: 5em;
        height: 5em;
        margin: 0 auto 0 auto;
        display: block;
        border-radius: 50%;
        border: 3px solid $primary;
        object-fit: cover;
      }

      h3 {
        text-align: center;
      }

      p {
        text-align: justify;
        line-height: 1.4em;
      }

      button {
        border-radius: 2px;
        padding: 5px;
        cursor: pointer;
        border: 2px solid $primary;
        background: none;

        &:focus {
          background: $primary;
          color: white;
          outline: none;
        }
      }
    }
  }

  .modal-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
    background: rgba(0, 0, 0, 0.6);
    display: none;

    .close-modal {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 99;
      background: $primary;
      color: white;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 2em;
      text-align: center;
      padding: 0 10px;
      border:none;
      cursor: pointer;

      &:focus {
        background: black;
        outline:none;
      }
    }

    .modal {
      position: absolute;
      top: 10vh;
      width: 40%;
      left: 50%;
      transform: translate(-50%, 0);
      height: 90vh;
      z-index: 100;
      background: white;
      padding: 2em;
      overflow-y: scroll;

      @media(max-width: 580px) {
        top: 2em;
        width: calc(100vw - 4em);
      }

      p {
        line-height: 1.8em;
        padding-bottom: 3em;
      }

      img {
        max-height: 20vh;
        margin-right: 2em;
        float: left;

        @media(max-width: 580px) {
          float: none;
        }
      }

      h1 {
        margin-bottom: 0;
      }

    }

    &.open {
      display: block;
    }
  }
</style>